import React from "react";
import Navbar from "../Navbar";
import NavbarBottom from "../NavbarBottom";
import IncomeChart from "./IncomeChart";
import ExpenseChart from "./ExpenseChart";
import { makeStyles } from "@material-ui/core/styles";
import ExpensesAndIncome from "./ExpensesAndIncome";

const useStyles = makeStyles(() => ({
  incomeChart: {
    marginBottom: 30,
    marginTop: 100,
  },
  expensesAndIncome: {
    marginBottom: 100,
    marginTop: 30,
  },
}));

export default function Statistics() {
  const classes = useStyles();

  return (
    <div>
      <Navbar />
      <div className={classes.incomeChart}>
        <IncomeChart />
      </div>
      <div>
        <ExpenseChart />
      </div>
      <div className={classes.expensesAndIncome}>
        <ExpensesAndIncome />
      </div>
      <NavbarBottom />
    </div>
  );
}
